import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';

const ImageGrid = styled(Grid)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: 'auto auto auto',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  '& > div:first-child': {
    gridColumn: '1 / 3',
    gridRow: '1',
  },
  '& > div:nth-child(4)': {
    gridColumn: '1 / 3',
    gridRow: '3',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
    '& > div:first-child': {
      gridColumn: '1',
    },
    '& > div:nth-child(4)': {
      gridColumn: '1',
    },
  },
}));

const ImageContainer = styled('div')({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
});

const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

function ImageGallery({ images }) {    
  if (!images || images.length === 0) {
    return <Box>No images to display.</Box>;
  }

  const imagesToRender = images.slice(0, 10);

  return (
    <ImageGrid container>
      {imagesToRender.map((imageUrl, index) => {
        if (index === 0 || index === 3) {
          return (
            <Grid item key={imageUrl}> {/* Use imageUrl as key */}
              <Box sx={{ height: '175px', overflow: 'hidden', borderRadius: '4px' }}>
                <StyledImage src={imageUrl} alt={`Image ${index + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
            </Grid>
          );
        } else {
          return (
            <Grid item key={imageUrl}> {/* Use imageUrl as key */}
              <ImageContainer>
                <StyledImage src={imageUrl} sx={{ borderRadius: '4px' }} alt={`Image ${index + 1}`} />
              </ImageContainer>
            </Grid>
          );
        }
      })}
    </ImageGrid>
  );
}

export default ImageGallery;